(function (angular) {
    /**
    * Directive to broadcast when the enter button has been pressed
    */
    angular.module('app')
        .directive('keypressEvents', ['$document', '$rootScope', function ($document, $rootScope) {
            return {
                restrict: 'A',
                link: function () {
                    $document.bind('keypress', function (e) {
                        if (e.charCode === 13) {
                            $rootScope.$broadcast('keypress', e, String.fromCharCode(e.which));
                        }
                    });
                }
            }
        }]);

})(angular);